<template>
  <v-app>
    <v-content>
      <v-main>
        <Training />
      </v-main>
      <!-- <div class="d-flex"> -->

      <v-footer padless fixed>
        <v-col class="text-center" cols="12">
          {{ new Date().getFullYear() }} — <strong>AIed.Inc</strong>
        </v-col>
      </v-footer>

      <!-- <div class="d-flex d-sm-none"> -->
      <div class="d-none">
        <v-bottom-navigation
          v-model="value"
          active-class="white"
          app
          dark
          class="cyan darken-1"
          mandatory
          shift
        >
          <router-link to="/">
            <v-btn class="cyan darken-1" active-class="white">
              <span>Training</span>

              <v-icon>mdi-message-processing-outline</v-icon>
            </v-btn>
          </router-link>

          <router-link to="/phonics">
            <v-btn class="cyan darken-1" active-class="white">
              <span>Word</span>

              <v-icon>mdi-alphabetical-variant</v-icon>
            </v-btn>
          </router-link>

          <router-link to="/sentences">
            <v-btn class="cyan darken-1" active-class="white">
              <span>Sentence</span>

              <v-icon>mdi-food-apple</v-icon>
            </v-btn>
          </router-link>
        </v-bottom-navigation>
      </div>
    </v-content>
  </v-app>
</template>

<script>
import Training from "./views/training.vue";

export default {
  name: "App",
  components: {
    Training,
  },
  data() {
    return {
      drawer: null,
      links: [
        { route: "/training" },
        { route: "/alphabet" },
        { route: "/words" },
      ],
    };
  },
  // data: () => ({
  //   //
  // }),
};
</script>
